var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDangerousGoods = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 2,
  d: "M3.414 12 11.9 3.515 20.385 12l-8.486 8.485z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m11 13.704-.5-6h3l-.5 6zm1.015 3a.98.98 0 0 1-.723-.296.96.96 0 0 1-.292-.701q0-.437.292-.717.293-.28.723-.28.432 0 .708.28a.98.98 0 0 1 .277.717q0 .405-.277.7a.93.93 0 0 1-.708.297"
})));
export default SvgDangerousGoods;